import api from "../../../api/api";


const getAssociateScheduleByDay = (dayNo) =>{
    return new Promise((resolve, reject)=>{
        api.get("associate/schedule/day/"+dayNo).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
} 


const save = (payload) => {
    return new Promise((resolve, reject)=>{
        api.post("associate/business-hours",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const setup = (payload) => {
    return new Promise((resolve, reject)=>{
        api.post("associate/business-hours/setup",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const scheduleUpdateServices = {
    getAssociateScheduleByDay,
    save,
    setup
    
}

export default scheduleUpdateServices;